module.exports = __webpack_public_path__ + "static/assets/5f6e6debfc04be0836d42b45ea85a6bb.png";